'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import { type ReactNode } from 'react';
import React from 'react';
import { type Spacing, getInnerSpacingClassNames, getOuterSpacingClassNames } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
export type ContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode[] | ReactNode;
  includedChildren?: any[];
  attributes?: any;
  innerSpacing?: Spacing;
  outerSpacing?: Spacing;
  backgroundColor?: string;
  backgroundImage?: string;
  rounded?: boolean;
  includeContentPadding?: boolean;
  fill?: boolean;
};
export const Container = t0 => {
  const $ = _c(40);
  let attributes;
  let backgroundColor;
  let builderBlock;
  let children;
  let containerProps;
  let contentPadding;
  let includedChildren;
  let innerSpacing;
  let rounded;
  let shouldRenderBuilderBlocks;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    const {
      className,
      children: t4,
      innerSpacing: t5,
      includedChildren: t6,
      outerSpacing,
      backgroundColor: t7,
      backgroundImage,
      rounded: t8,
      fill,
      includeContentPadding,
      ...props
    } = t0;
    children = t4;
    innerSpacing = t5;
    includedChildren = t6;
    backgroundColor = t7;
    rounded = t8;
    const {
      builderState,
      builderBlock: t9,
      attributes: t10,
      ...t11
    } = props as any;
    builderBlock = t9;
    attributes = t10;
    containerProps = t11;
    let t12;
    if ($[14] !== children) {
      t12 = () => !React.Children.count(children);
      $[14] = children;
      $[15] = t12;
    } else {
      t12 = $[15];
    }
    shouldRenderBuilderBlocks = t12;
    const pageMargins = fill ? "px-0" : "px-4 sm:px-8 lg:px-16";
    contentPadding = fill || !includeContentPadding ? "px-0" : "px-6 sm:px-8 lg:px-16";
    t1 = attributes;
    t2 = attributes?.key;
    t3 = cn("mx-auto w-full max-w-(--breakpoint-2xl)", getOuterSpacingClassNames(outerSpacing), pageMargins, className, attributes?.className, {
      "max-w-full": fill
    });
    $[0] = t0;
    $[1] = attributes;
    $[2] = backgroundColor;
    $[3] = builderBlock;
    $[4] = children;
    $[5] = containerProps;
    $[6] = contentPadding;
    $[7] = includedChildren;
    $[8] = innerSpacing;
    $[9] = rounded;
    $[10] = shouldRenderBuilderBlocks;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    attributes = $[1];
    backgroundColor = $[2];
    builderBlock = $[3];
    children = $[4];
    containerProps = $[5];
    contentPadding = $[6];
    includedChildren = $[7];
    innerSpacing = $[8];
    rounded = $[9];
    shouldRenderBuilderBlocks = $[10];
    t1 = $[11];
    t2 = $[12];
    t3 = $[13];
  }
  const t4 = attributes?.style;
  let t5;
  if ($[16] !== t4) {
    t5 = {
      ...t4
    };
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== contentPadding || $[19] !== innerSpacing || $[20] !== rounded) {
    t6 = cn("w-full", contentPadding, getInnerSpacingClassNames(innerSpacing), {
      "rounded-[30px]": rounded
    });
    $[18] = contentPadding;
    $[19] = innerSpacing;
    $[20] = rounded;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== backgroundColor) {
    t7 = {
      backgroundColor
    };
    $[22] = backgroundColor;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== builderBlock?.id || $[25] !== children || $[26] !== includedChildren || $[27] !== shouldRenderBuilderBlocks) {
    t8 = shouldRenderBuilderBlocks() ? includedChildren?.map((child, index) => <BuilderBlocks key={child.item?.[0]?.id || index} parentElementId={builderBlock?.id} dataPath={`component.options.includedChildren.${index}.item`} blocks={child.item} style={{
      minHeight: "auto !important"
    }} />) : children;
    $[24] = builderBlock?.id;
    $[25] = children;
    $[26] = includedChildren;
    $[27] = shouldRenderBuilderBlocks;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t6 || $[30] !== t7 || $[31] !== t8) {
    t9 = <div className={t6} style={t7}>{t8}</div>;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== containerProps || $[34] !== t1 || $[35] !== t2 || $[36] !== t3 || $[37] !== t5 || $[38] !== t9) {
    t10 = <div {...t1} key={t2} className={t3} style={t5} {...containerProps} suppressHydrationWarning={true}>{t9}</div>;
    $[33] = containerProps;
    $[34] = t1;
    $[35] = t2;
    $[36] = t3;
    $[37] = t5;
    $[38] = t9;
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  return t10;
};